<template>
  <div>
    <div
      class="d-flex justify-content-center align-items-center h-75"
      v-if="carregando"
    >
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <div v-else>
      <modal name="modal-detalhes-licenciada" width="550px" height="auto">
        <modal-detalhes-licenciada
          @botao-voltar="$modal.hide('modal-detalhes-licenciada')"
          @botao-editar="editarSistema($event)"
          @exibir-toast="exibirToast($event)"
          :item="itemSelecionado"
        />
      </modal>
      <modal name="configuracoes-extra" width="700px" height="540px">
        <configuracoes-extras
          @botao-voltar="$modal.hide('configuracoes-extra')"
          :licenciada="itemSelecionado"
        />
      </modal>

      <!-- Visão panorâmica: contagens rápidas de sistemas/conectores. -->
      <div class="pnc-resumo">
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone" style="color: #7239ea"
            ><i class="fas fa-database"></i
          ></span>
          <div>
            <span class="pnc-resumo__valor">{{ sistemas.length }}</span>
            <span class="pnc-resumo__rotulo">Sistemas conectados</span>
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone" style="color: #00a884"
            ><i class="fas fa-circle-nodes"></i
          ></span>
          <div>
            <span class="pnc-resumo__valor">{{ licenciadas.length }}</span>
            <span class="pnc-resumo__rotulo">Conectores</span>
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone" style="color: #00a884"
            ><i class="fas fa-circle-check"></i
          ></span>
          <div>
            <span class="pnc-resumo__valor">{{ qtdConectoresOnline }}</span>
            <span class="pnc-resumo__rotulo">Conectores online</span>
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone" style="color: #3699ff"
            ><i class="fas fa-clock"></i
          ></span>
          <div>
            <span class="pnc-resumo__valor">{{
              ultimaComunicacao || "—"
            }}</span>
            <span class="pnc-resumo__rotulo">Última comunicação</span>
          </div>
        </div>
      </div>

      <div class="pnc-secao">
        <h6 class="pnc-titulo">
          Sistemas conectados
          <span class="pnc-titulo__contador">{{ sistemas.length }}</span>
        </h6>

        <!-- Reiniciar o conector ou mandar atualizar a licenca muda o
        status quase na hora, mas so refletia aqui reabrindo o modal.
        Cooldown de 10s pra nao virar um jeito de martelar o backend. -->
        <button
          type="button"
          class="card-acao"
          :disabled="cooldownAtivo"
          v-b-tooltip.hover
          :title="
            cooldownAtivo
              ? 'Aguarde alguns segundos para atualizar novamente'
              : 'Atualizar status dos conectores e sistemas'
          "
          @click="atualizarManual"
        >
          <i :class="['fas', 'fa-rotate', { 'fa-spin': atualizando }]"></i>
          Atualizar
        </button>
      </div>

      <b-table
        id="tabelaSistemasConectados"
        small
        :current-page="paginacaoSistemas.paginaAtual"
        :per-page="paginacaoSistemas.porPagina"
        :fields="fieldsSistemas"
        :items="sistemasEnriquecidos"
        responsive="sm"
        hover
      >
        <template #cell(sli_titulo)="row">
          <div class="mt-3" title="Ver detalhes" @click="detalhes(row.item)">
            {{ row.item.sli_titulo }}
            <small class="d-block text-muted">{{
              row.item.label_sist_banco
            }}</small>
          </div>
        </template>

        <template #cell(tipoConexao)="row">
          <span
            class="pnc-badge"
            :style="{
              color: row.item.tipoConexao.cor,
              background: row.item.tipoConexao.fundo
            }"
          >
            <i :class="['fas', row.item.tipoConexao.icone]"></i>
            {{ row.item.tipoConexao.label }}
          </span>
        </template>

        <template #cell(sli_db_dsn)="data">
          <div
            class="mt-3"
            style="inline-size: 260px; overflow-wrap: break-word"
          >
            {{ data.value || "—" }}
          </div>
        </template>

        <template #cell(conectorDescricao)="row">
          <div class="d-flex align-items-center mt-3">
            <i class="fas fa-circle-nodes mr-2" style="color: #b5b5c3"></i>
            {{ row.item.conectorDescricao || "—" }}
          </div>
        </template>

        <template #cell(sli_data_ativacao)="data">
          <div class="mt-3">{{ obterDataFormatada(data.value) }}</div>
        </template>

        <template #cell(testarConexao)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            :disabled="!row.item.podeTestarConexao"
            v-b-tooltip.hover
            :title="
              row.item.podeTestarConexao
                ? ''
                : 'Teste de conexão não disponível para este tipo de sistema'
            "
            @click="testarConexao(row.item)"
          >
            <i class="fas fa-plug mr-1"></i> Testar conexão
          </b-button>
        </template>

        <template #cell(acoes)="row">
          <b-dropdown
            no-caret
            variant="outline-secondary"
            dropleft
            class="border-0"
          >
            <template #button-content>
              <i class="fas fa-ellipsis-vertical"></i>
            </template>
            <b-dropdown-item @click="detalhes(row.item)"
              ><i class="fas fa-circle-info mr-2"></i>Detalhes</b-dropdown-item
            >
            <b-dropdown-item
              v-if="row.item.sistema_obj.sis_visibilidade"
              @click="editarSistema(row.item)"
              ><i class="fas fa-pen mr-2"></i>Editar</b-dropdown-item
            >
            <b-dropdown-item @click="exibirConfiguracoesExtras(row.item)"
              ><i class="fas fa-sliders mr-2"></i>Propriedades</b-dropdown-item
            >
            <b-dropdown-item @click="apagarSistema(row.item)"
              ><i class="fas fa-trash mr-2"></i>Remover</b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>
      <div class="d-flex justify-content-center" v-if="sistemas.length">
        <b-pagination
          v-model="paginacaoSistemas.paginaAtual"
          :total-rows="sistemas.length"
          :per-page="paginacaoSistemas.porPagina"
          aria-controls="tabelaSistemasConectados"
          align="fill"
        ></b-pagination>
      </div>
      <div v-else class="pnc-vazio">Nenhum sistema conectado ainda.</div>

      <div class="pnc-secao mt-6">
        <h6 class="pnc-titulo">
          Conectores
          <span class="pnc-titulo__contador">{{ licenciadas.length }}</span>
        </h6>

        <!-- 3 por vez; o resto entra deslizando. -->
        <div v-if="totalPaginasConectores > 1" class="pnc-slide-nav">
          <button
            type="button"
            class="pnc-slide-btn"
            :disabled="paginaConectores === 0"
            title="Anteriores"
            @click="paginaConectores--"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="pnc-slide-pos"
            >{{ paginaConectores + 1 }}/{{ totalPaginasConectores }}</span
          >
          <button
            type="button"
            class="pnc-slide-btn"
            :disabled="paginaConectores >= totalPaginasConectores - 1"
            title="Próximos"
            @click="paginaConectores++"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <div class="pnc-conectores">
        <div
          v-for="conector in conectoresVisiveis"
          :key="conector.licenciada_id"
          class="pnc-conector"
        >
          <div class="pnc-conector__cabecalho">
            <div class="d-flex align-items-center">
              <span
                :class="[
                  'pnc-conector__status',
                  conector.online
                    ? 'pnc-conector__status--online'
                    : 'pnc-conector__status--offline'
                ]"
              ></span>
              <strong>{{ conector.lic_descricao }}</strong>
            </div>
            <b-dropdown
              no-caret
              variant="outline-secondary"
              dropleft
              size="sm"
              class="border-0"
            >
              <template #button-content>
                <i class="fas fa-ellipsis-vertical"></i>
              </template>
              <b-dropdown-item @click="editarConector(conector)"
                ><i class="fas fa-pen mr-2"></i>Editar</b-dropdown-item
              >
              <b-dropdown-item @click="atualizarCredenciaisConector(conector)"
                ><i class="fas fa-rotate mr-2"></i>Atualizar
                credenciais</b-dropdown-item
              >
              <b-dropdown-item @click="apagarConector(conector)"
                ><i class="fas fa-trash mr-2"></i>Remover</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <div class="pnc-conector__linha">
            {{ conector.online ? "Online" : "Offline" }}
            <template v-if="conector.lic_versao">
              · Versão {{ conector.lic_versao }}</template
            >
          </div>
          <div class="pnc-conector__linha text-muted">
            {{
              conector.online
                ? conector.onlineDesde
                : "Última comunicação: " + conector.onlineDesde
            }}
          </div>
          <div class="pnc-conector__rodape">
            <i class="fas fa-database mr-1"></i>
            {{ conector.qtdSistemas }}
            {{
              conector.qtdSistemas === 1
                ? "sistema vinculado"
                : "sistemas vinculados"
            }}
          </div>
        </div>
        <div v-if="!licenciadas.length" class="pnc-vazio">
          Nenhum conector cadastrado ainda.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDetalhesLicenciada from "../licenciada/components/ModalDetalhesLicenciada.vue";
import ConfiguracoesExtras from "../licenciada/components/ConfiguracoesExtras.vue";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import API_LINKS from "../api.links";
import moment from "moment";

// Tipos sem consulta SQL de teste cadastrada por trás (DataNetProvider::
// testarConexaoSistema exige BancoTipo::bat_sql_teste) -- nao e falta de
// implementar o botao, e que esses tipos nao tem como ser testados hoje.
const TIPOS_SEM_TESTE_CONEXAO = ["API_E", "API_G", "WHK"];

const TIPO_CONEXAO = {
  API_E: { label: "API", icone: "fa-plug", cor: "#3699ff", fundo: "#e1f0ff" },
  API_G: { label: "API", icone: "fa-plug", cor: "#3699ff", fundo: "#e1f0ff" },
  WHK: {
    label: "Webhook",
    icone: "fa-link",
    cor: "#7c7c8a",
    fundo: "#f3f6f9"
  }
};
const TIPO_CONEXAO_PADRAO = {
  label: "Banco de Dados",
  icone: "fa-database",
  cor: "#7239ea",
  fundo: "#f2eefa"
};

export default {
  name: "PainelConectores",
  components: {
    ModalDetalhesLicenciada,
    ConfiguracoesExtras
  },
  props: {
    contaId: { type: Number, default: null }
  },
  data() {
    return {
      carregando: true,
      atualizando: false,
      cooldownAtivo: false,
      sistemas: [],
      licenciadas: [],
      listaLicencasOnline: [],
      bancos: [],
      sistemasCatalogo: [],
      itemSelecionado: {},
      paginacaoSistemas: {
        paginaAtual: 1,
        porPagina: 5
      },
      paginaConectores: 0,
      CONECTORES_POR_PAGINA: 3,
      fieldsSistemas: [
        { key: "sli_titulo", label: "Sistema" },
        { key: "tipoConexao", label: "Tipo de conexão" },
        { key: "sli_db_dsn", label: "Endereço" },
        { key: "conectorDescricao", label: "Conector" },
        { key: "sli_data_ativacao", label: "Último teste" },
        { key: "testarConexao", label: "Testar conexão", class: "text-center" },
        { key: "acoes", label: "Ações", class: "text-center" }
      ]
    };
  },
  computed: {
    sistemasEnriquecidos() {
      const licenciadaPorId = {};
      this.licenciadas.forEach((l) => {
        licenciadaPorId[l.licenciada_id] = l;
      });

      return this.sistemas.map((sis) => {
        const sistemaObj = this.sistemasCatalogo.find(
          (s) => s.sistema_id == sis.sistema_id
        );
        const bancoObj = this.bancos.find(
          (b) => b.banco_id.trim() == sis.banco_id.trim()
        );
        const conector = licenciadaPorId[sis.licenciada_id];

        return {
          ...sis,
          sistema_obj: sistemaObj,
          banco_obj: bancoObj,
          label_sist_banco: sistemaObj
            ? `${sistemaObj.sis_nome} - ${bancoObj ? bancoObj.bat_nome : ""}`
            : "",
          conectorDescricao: conector ? conector.lic_descricao : null,
          tipoConexao: TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO,
          podeTestarConexao: !TIPOS_SEM_TESTE_CONEXAO.includes(sis.banco_id)
        };
      });
    },
    // Ativo antes de inativo; dentro de cada grupo, do mais novo pro mais
    // antigo -- o que acabou de ser cadastrado e o que a pessoa procura.
    conectoresEnriquecidos() {
      return this.licenciadas
        .map((lic) => {
          const online = this.listaLicencasOnline.some(
            (i) => i.lic_token == lic.lic_token
          );
          const qtdSistemas = this.sistemas.filter(
            (s) => s.licenciada_id === lic.licenciada_id
          ).length;

          return {
            ...lic,
            online,
            qtdSistemas,
            onlineDesde: this.formatarUltimaComunicacao(lic.lic_token)
          };
        })
        .sort((a, b) => {
          const ativoA = a.lic_status === "A" ? 0 : 1;
          const ativoB = b.lic_status === "A" ? 0 : 1;
          if (ativoA !== ativoB) return ativoA - ativoB;

          return Number(b.licenciada_id || 0) - Number(a.licenciada_id || 0);
        });
    },
    totalPaginasConectores() {
      return Math.max(
        1,
        Math.ceil(
          this.conectoresEnriquecidos.length / this.CONECTORES_POR_PAGINA
        )
      );
    },
    conectoresVisiveis() {
      const inicio = this.paginaConectores * this.CONECTORES_POR_PAGINA;
      return this.conectoresEnriquecidos.slice(
        inicio,
        inicio + this.CONECTORES_POR_PAGINA
      );
    },
    qtdConectoresOnline() {
      return this.conectoresEnriquecidos.filter((c) => c.online).length;
    },
    ultimaComunicacao() {
      const datas = this.listaLicencasOnline
        .map((i) => i.created_at)
        .filter(Boolean)
        .map((d) => moment(d));

      if (!datas.length) return null;

      const maisRecente = moment.max(datas);
      return maisRecente.format("DD/MM/YYYY HH:mm");
    }
  },
  methods: {
    formatarUltimaComunicacao(licToken) {
      const online = this.listaLicencasOnline.find(
        (i) => i.lic_token == licToken
      );
      return online
        ? moment(online.created_at).format("DD/MM/YYYY HH:mm")
        : "sem registro";
    },

    detalhes(item) {
      this.itemSelecionado = item;
      this.$modal.show("modal-detalhes-licenciada");
    },
    exibirConfiguracoesExtras(sistema) {
      this.itemSelecionado = sistema;
      this.$modal.show("configuracoes-extra");
    },
    editarSistema(item) {
      this.itemSelecionado = item;
      this.$emit("editar-licenciada", item.sistema_licenciada_id);
    },
    apagarSistema(item) {
      this.itemSelecionado = item;
      Swal.fire({
        title: 'Você deseja remover o sistema "' + item.sli_titulo + '"?',
        text: "Não será possivel reverter essa ação! Você pode desativar o sistema sem precisar removê-lo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, quero remover!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (!result.isConfirmed) return;

        ApiService.delete(
          API_LINKS.sistemaLicenciada + "/" + item.sistema_licenciada_id
        ).then(() => {
          Swal.fire(
            "Removido",
            "Seu sistema foi removido com sucesso!",
            "success"
          );
          this.pegarDados();
        });
      });
    },
    async testarConexao(item) {
      this.exibirToast({
        severity: "info",
        summary: "Testando a conexão com o sistema",
        detail:
          "Isso pode demorar uma pouco! Mas logo iremos informar o resultado.",
        life: 5000
      });

      let response = await ApiService.get(
        API_LINKS.sistemaLicenciadaTestarConexao,
        item.sistema_licenciada_id
      );
      let requisicao = response.data.requisicao;
      if (requisicao.sucesso) {
        ApiService.get(
          API_LINKS.sistemaLicenciadaRespostaTesteConexao,
          item.sistema_licenciada_id + "/" + requisicao.uid
        )
          .then((response) => {
            requisicao = response.data.requisicao;
            const payload = requisicao.requisicao.resultado;
            if (requisicao.requisicao.sucesso_requisicao) {
              this.exibirToast({
                severity: "success",
                summary: "Teste de conexão bem sucedido!",
                detail: `Verificamos suas credenciais e tudo está funcionando corretamente. Resultado: ${JSON.stringify(
                  payload
                )}`,
                life: 7000
              });
              this.pegarDados();
            } else {
              this.exibirToast({
                severity: "error",
                summary: "Erro no teste de conexão",
                detail: `Verificamos suas credenciais e não foi possível se conectar!. Resultado: ${JSON.stringify(
                  payload
                )}`,
                life: 7000
              });
            }
          })
          .catch(() => {
            this.exibirToast({
              severity: "error",
              summary: "Erro no teste de conexão",
              detail: "Não foi possível se conectar ao sistema.",
              life: 7000
            });
          });
      } else {
        this.exibirToast({
          severity: "error",
          summary: "Erro no teste de conexão",
          detail: "Não foi possível solicitar o teste de conexão.",
          life: 7000
        });
      }
    },

    editarConector(item) {
      this.$emit("editar-conector", item);
    },
    apagarConector(item) {
      Swal.fire({
        title: 'Você deseja remover o conector "' + item.lic_descricao + '"?',
        text: "Não será possivel reverter essa ação! Você pode desativar o conector sem precisar removê-lo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, quero remover!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (!result.isConfirmed) return;

        ApiService.delete(API_LINKS.licenca + "/" + item.licenciada_id).then(
          () => {
            Swal.fire(
              "Removido",
              "Seu conector foi removido com sucesso!",
              "success"
            );
            this.pegarDados();
          }
        );
      });
    },
    async atualizarCredenciaisConector(item) {
      this.exibirToast({
        severity: "info",
        summary: "Atualizando credenciais",
        detail:
          "Estamos entrando em contato com o conector para atualizar suas credenciais!",
        life: 4000
      });
      try {
        await ApiService.get(
          API_LINKS.forcarAtualizarCredenciais,
          item.licenciada_id,
          false
        );
        this.exibirToast({
          severity: "success",
          summary: "Suas credenciais foram atualizadas!",
          detail:
            "Atualizamos as informações de conexão contidas no conector! Isso pode demorar um pouco para surtir efeito.",
          life: 7000
        });
      } catch (error) {
        this.exibirToast({
          severity: "error",
          summary: "Erro em atualizar suas credenciais",
          detail:
            "Aconteceu um erro durante a tentativa de conexão com o conector! Tente novamente mais tarde.",
          life: 7000
        });
      }
    },

    obterDataFormatada(data) {
      return data
        ? moment(data, "YYYY-MM-DD HH:mm:ss")
            .locale("pt-br")
            .format("DD/MM/YYYY HH:mm")
        : "—";
    },
    exibirToast(toast) {
      this.$toast.removeAllGroups();
      this.$toast.add(toast);
    },

    // mostrarCarregamento=false: usado pelo botao "Atualizar" -- troca os
    // dados no lugar, sem cobrir a tela inteira com o spinner de novo.
    pegarDados(mostrarCarregamento = true) {
      if (mostrarCarregamento) this.carregando = true;
      const query = this.contaId ? `?conta_id=${this.contaId}` : "";

      return Promise.all([
        ApiService.get(API_LINKS.banco, "", false),
        ApiService.get(API_LINKS.sistema, "", false),
        ApiService.get(API_LINKS.sistemaLicenciada, query, false),
        ApiService.get(API_LINKS.licenca, query, false),
        // query aqui tambem: sem o conta_id o backend compara os tokens
        // online contra as licenciadas da conta logada, e todo conector de
        // outra conta aparecia offline na Central.
        ApiService.get(API_LINKS.licencasOnlines, query, false)
      ]).then(
        ([
          respBancos,
          respSistemas,
          respSistemaLicenciada,
          respLicenca,
          respOnline
        ]) => {
          this.bancos = respBancos.data.bancos;
          this.sistemasCatalogo = respSistemas.data.sistemas;
          this.sistemas = respSistemaLicenciada.data.sistemas;
          this.licenciadas = respLicenca.data.licenciadas;
          // agentes ja vem como lista de objetos com lic_token/created_at
          // direto do DataNetProvider::pegarLicencasOnline. O .map(item =>
          // item[0]) copiado do arquivo antigo so gerava undefined aqui.
          this.listaLicencasOnline = respOnline.data.agentes || [];

          this.carregando = false;
        }
      );
    },

    // Reinicio de agente / atualizacao de licenca refletem quase na hora
    // no backend, mas so apareciam aqui fechando e reabrindo o modal.
    atualizarManual() {
      if (this.cooldownAtivo) return;

      this.atualizando = true;
      this.pegarDados(false).finally(() => {
        this.atualizando = false;
      });

      this.cooldownAtivo = true;
      setTimeout(() => {
        this.cooldownAtivo = false;
      }, 10000);
    }
  },
  watch: {
    // Remover um conector (ou trocar de conta) pode encolher a lista e
    // deixar a pagina atual fora do intervalo, mostrando um slide vazio.
    totalPaginasConectores(total) {
      if (this.paginaConectores > total - 1) {
        this.paginaConectores = Math.max(0, total - 1);
      }
    }
  },
  mounted() {
    this.pegarDados();
  }
};
</script>

<style lang="scss" scoped>
.pnc-resumo {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.pnc-resumo__item {
  flex: 1 1 190px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border: 1px solid #ebedf3;
  border-radius: 0.5rem;
}

.pnc-resumo__icone {
  font-size: 1.4rem;
  width: 2.2rem;
  text-align: center;
}

.pnc-resumo__valor {
  display: block;
  font-size: 1.15rem;
  font-weight: 700;
  color: #2b2640;
}

.pnc-resumo__rotulo {
  display: block;
  font-size: 0.75rem;
  color: #7c7c8a;
}

// Titulo + acao na mesma linha, mesmo arranjo dos cards do Dashboard.
.pnc-secao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

// Mesma escala do .card-titulo global (1.1rem) usada no Dashboard.
.pnc-titulo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2b2640;
}

.pnc-titulo__contador {
  background: #f3f6f9;
  color: #7c7c8a;
  border-radius: 999px;
  padding: 0.05rem 0.55rem;
  font-size: 0.75rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.pnc-slide-nav {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.pnc-slide-pos {
  font-size: 0.75rem;
  font-weight: 600;
  color: #7c7c8a;
  font-variant-numeric: tabular-nums;
}

.pnc-slide-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1.5px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  color: #7c7c8a;
  cursor: pointer;
  transition: all 0.15s ease;

  i {
    font-size: 0.75rem !important;
  }

  &:hover:not(:disabled) {
    color: #472282;
    border-color: #472282;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

.pnc-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
}

.pnc-vazio {
  padding: 1.5rem;
  text-align: center;
  color: #b5b5c3;
}

.pnc-conectores {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

// Mesma borda de 2.5px dos cards do Dashboard/Timeline.
.pnc-conector {
  flex: 1 1 260px;
  min-width: 0;
  border: 2.5px solid #ebedf3;
  border-radius: 10px;
  padding: 1rem;
}

.pnc-conector__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  strong {
    font-size: 0.9rem;
    font-weight: 600;
    color: #2b2640;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.pnc-conector__status {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 0.5rem;
  flex: 0 0 9px;

  &--online {
    background: #00a884;
  }

  &--offline {
    background: #d61515;
  }
}

.pnc-conector__linha {
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #5e6278;
}

.pnc-conector__rodape {
  margin-top: 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #7c7c8a;
}

// A tabela vinha com a tipografia default do b-table, destoando dos cards.
::v-deep #tabelaSistemasConectados {
  th {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #b5b5c3;
    border-top: 0;
  }

  td {
    font-size: 0.85rem;
    color: #2b2640;
    vertical-align: middle;
  }

  small {
    font-size: 0.72rem;
  }
}
</style>
